import { SITE_NAME, SITE_TAGLINE } from '../constants/site';

export default function Logo({ compact = false, light = false }) {
  return (
    <span className={`brand ${light ? 'brand--light' : ''}`}>
      <span className="brand__mark" aria-hidden="true">
        <svg viewBox="0 0 32 32" width="26" height="26" role="presentation">
          <path
            d="M16 2.5 4.8 7.2v8.1c0 6.6 4.6 12.7 11.2 14.7 6.6-2 11.2-8.1 11.2-14.7V7.2L16 2.5Z"
            fill="currentColor"
          />
          <path
            d="M10.5 15.8 14.4 19.7 21.8 12.3"
            fill="none"
            stroke="#fff"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {!compact && (
        <span className="brand__text">
          <span className="brand__name">{SITE_NAME}</span>
          <span className="brand__sub">{SITE_TAGLINE}</span>
        </span>
      )}
    </span>
  );
}
